import React, { FC, forwardRef } from 'react';
import MuiAvatar, { AvatarProps as MuiAvatarProps } from '@material-ui/core/Avatar';
import { Uds } from '../../types';

export type CustomSizesKeys =
  | 'small'
  | 'smallToMedium'
  | 'medium'
  | 'large'
  | 'extraLarge'
  | 'extraExtraLarge'
  | number;

export type AvatarProps = Uds<
  MuiAvatarProps & {
    alt?: string;
    fallback?: string;
    src?: string;
    sizes?: string;
    classes?: object;
    customSize?: CustomSizesKeys;
    customInitialsSize?: number;
    children?: React.ReactNode;
  }
>;

export const Avatar = forwardRef(
  (
    { alt, fallback, src, sizes, classes, variant, customSize, dataTest, children, style, customInitialsSize, ...rest },
    ref
  ) => {
    const size = getSize(customSize, customInitialsSize);
    return (
      <MuiAvatar
        alt={alt}
        data-test={dataTest}
        src={src}
        sizes={sizes}
        classes={classes}
        variant={variant}
        style={{ ...style, ...size }}
        ref={ref}
        {...rest}
        children={
          fallback || children ? (
            <>
              {fallback}
              {children}
            </>
          ) : undefined
        }
      />
    );
  }
) as FC<React.PropsWithChildren<AvatarProps>>;

export default Avatar;

function getSize(size?: CustomSizesKeys, initialsSize?: number): { height: number; width: number; fontSize?: number } {
  let result: { height: number; width: number; fontSize?: number } = { ...PREDEFINED_SIZES.smallToMedium };
  if (typeof size !== 'undefined') {
    result = typeof size === 'number' ? { height: size, width: size } : { ...PREDEFINED_SIZES[size] };
  }
  if (typeof initialsSize === 'number') {
    result.fontSize = initialsSize;
  }
  return result;
}

const PREDEFINED_SIZES = {
  small: {
    height: 16,
    width: 16
  },
  smallToMedium: {
    width: 30,
    height: 30
  },
  medium: {
    height: 36,
    width: 36
  },
  large: {
    width: 40,
    height: 40
  },
  extraLarge: {
    width: 56,
    height: 56
  },
  extraExtraLarge: {
    width: 88,
    height: 91
  }
};
